import { Text, View } from "react-native";
import Flag from "react-native-flags";

type LanguageItemProps = Readonly<{
  name: string;
  code: string;
}>;

const LanguageItem = ({ name, code }: LanguageItemProps) => {
  return (
    <View className="flex-row items-center gap-1">
      {/* code is being received as ex: en-US */}
      <Flag code={code.split("-")[1]} size={16} />{" "}
      <Text className="text-slate">{name}</Text>
    </View>
  );
};

export default LanguageItem;
